import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, RouterStateSnapshot } from "@angular/router";
import { map } from "rxjs";
import { AuthenticationService } from "./services/authentication/authentication.service";

/**
 * Blocks forgot/reset password routes when backend disables password reset
 * (SsoOnly or LdapFailover). Loads LoginConfiguration on demand when not yet cached.
 */
export const canActivateGuardOnlySSO: CanActivateFn = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const auth = inject(AuthenticationService);
  return auth.ensureLoginConfiguration().pipe(map(() => auth.isPasswordResetEnabled()));
};

export const canActivateChildGuardOnlySSO: CanActivateChildFn = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const auth = inject(AuthenticationService);
  return auth.ensureLoginConfiguration().pipe(map(() => auth.isPasswordResetEnabled()));
};
